module.exports = __webpack_public_path__ + "img/arrow-right.4071d171.svg";